import { render, staticRenderFns } from "./MyMindContent.vue?vue&type=template&id=8fa64c2a"
import script from "./MyMindContent.vue?vue&type=script&lang=js"
export * from "./MyMindContent.vue?vue&type=script&lang=js"
import style0 from "./MyMindContent.vue?vue&type=style&index=0&id=8fa64c2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports